import React from "react";
import { useNavigate } from "react-router-dom";
import { closeModal } from "react-url-modal";
import { Modal, Button } from "@/components";
import styles from "./SuccessRequestSendModal.module.scss";
import successRequestSendIcon from "@/assets/img/successRequestSend.svg";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";

interface SuccessRequestSendModalProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  params?: Record<string, any>;
}

const SuccessRequestSendModalComponent = ({
  setIsOpen,
  params = {},
}: SuccessRequestSendModalProps): JSX.Element => {
  const navigate = useNavigate();
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;

  const handleClose = () => {
    closeModal();
    navigate("/padel/games/my");
    if (setIsOpen) {
      setIsOpen(false);
    }
  };

  return (
    <Modal
      title="Заявка отправлена!"
      subTitle="Ваша заявка на участие в игре успешно отправлена. Организатор свяжется с вами в ближайшее время."
      isOpen={true}
      setIsOpen={setIsOpen || (() => {})}
      closeModal={handleClose}
      firmBack
    >
      <div className={styles.content}>
        <img 
          src={successRequestSendIcon} 
          alt="success request send" 
          className={styles.image} 
        />
        {
          isMobile && (
            <div className={styles.mobileContent}>
              <span className={styles.mobileTitle}>
                Заявка успешно отправлена!
              </span>
              <span className={styles.mobileSubTitle}>
                Ваша заявка на участие в игре успешно отправлена. Организатор свяжется с вами в ближайшее время.
              </span>
            </div>
          )
        }
        <Button onClickFunc={handleClose} newStyles={styles.button}>
          Перейти в “Мои игры” 
        </Button>
      </div>
    </Modal>
  );
};

export default SuccessRequestSendModalComponent;
export const SuccessRequestSendModal = SuccessRequestSendModalComponent;
